import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { DefaultButton } from 'common/components';
import { FormattedMessage } from 'react-intl';
import Checkbox from 'common/components/Checkbox/Checkbox';
import { withTheme } from 'common/styling/theme';
import { GraphIcon, HatIcon, TreeIcon, UserCheckIcon } from 'common/icons';
import { staticStyles, getDynamicStyles } from './style';

const ChooseProgramModalContent = ({ onBecomePartner, onChooseReferFriend, theme }) => {
  const [isPartnerConfirmed, setIsPartnerConfirmed] = useState(false);
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  return (
    <div className="ChooseProgramModalContent">
      <FormattedMessage id="chooseProgramModalContentDescription">
        {txt => <p className="ChooseProgramModalContent__description">{txt}</p>}
      </FormattedMessage>

      <div className="ChooseProgramModalContent__criteria">
        <FormattedMessage id="chooseProgramModalContentCriteriaLabel">
          {txt => <span className="ChooseProgramModalContent__criteriaLabel">{txt}</span>}
        </FormattedMessage>
        <ul className="ChooseProgramModalContent__criteriaList">
          <FormattedMessage id="tradingEducatorOrAcademy">
            {txt => (
              <li>
                <HatIcon />
                {txt}
              </li>
            )}
          </FormattedMessage>
          <FormattedMessage id="introducingBrokerIB">
            {txt => (
              <li>
                <GraphIcon />
                {txt}
              </li>
            )}
          </FormattedMessage>
          <FormattedMessage id="contentCreatorWithAnActiveTradingAudience">
            {txt => (
              <li>
                <TreeIcon />
                {txt}
              </li>
            )}
          </FormattedMessage>
          <FormattedMessage id="professionalWithAnEstablishedClientBase">
            {txt => (
              <li>
                <UserCheckIcon />
                {txt}
              </li>
            )}
          </FormattedMessage>
        </ul>
      </div>

      <Checkbox
        checked={isPartnerConfirmed}
        onClick={() => setIsPartnerConfirmed(!isPartnerConfirmed)}
        textId="chooseProgramModalContentConfirm"
      />

      <div className="ChooseProgramModalContent__action">
        <div className="ChooseProgramModalContent__action-button">
          <DefaultButton
            type="button"
            onClick={onBecomePartner}
            textId="continueToPartnerProgram"
            filled
            disabled={!isPartnerConfirmed}
          />
        </div>
        <div className="ChooseProgramModalContent__action-button">
          <DefaultButton type="button" onClick={onChooseReferFriend} textId="takeMeToReferAFriendInstead" />
        </div>
      </div>

      <style jsx global>
        {staticStyles}
      </style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

ChooseProgramModalContent.propTypes = {
  onBecomePartner: PropTypes.func.isRequired,
  onChooseReferFriend: PropTypes.func.isRequired,
  theme: PropTypes.object,
};

ChooseProgramModalContent.defaultProps = {
  theme: {},
};

const ThemedChooseProgramModalContent = withTheme()(ChooseProgramModalContent);

export default ThemedChooseProgramModalContent;
